import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import LiveMarketTicker from "../components/LiveMarketTicker";
import ServicesGrid from "../components/ServicesGrid";
import Calculators from "../components/Calculators";
import LiveMarket from "../components/LiveMarket";
import WhyChooseUs from "../components/WhyChooseUs";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import BlogsSection from "../components/BlogsSection";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <Navbar />
      <Hero />
      <LiveMarketTicker />
      <ServicesGrid />
      <Calculators />
      <LiveMarket />
      <WhyChooseUs />
      <About />
      <Testimonials />
      <BlogsSection />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingActions />
    </div>
  );
}
